import script from "./MyComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./MyComponent.vue?vue&type=script&setup=true&lang=js"

import "./MyComponent.vue?vue&type=style&index=0&id=3d10cf0f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3d10cf0f"]])

export default __exports__